import React, { useCallback, useEffect, useRef, useState } from 'react';
import './GameWindow.css';

const GameWindow = () => {
  const iframeRef = useRef(null);
  const [showHint, setShowHint] = useState(true);

  const focusUnityGame = useCallback(() => {
    try {
      const iframe = iframeRef.current;
      if (!iframe) return;

      const iframeWindow = iframe.contentWindow;
      const iframeDoc = iframe.contentDocument || iframeWindow?.document;
      if (!iframeDoc) return;

      const canvas = iframeDoc.querySelector('#unity-canvas');

      iframe.focus();
      iframeWindow?.focus();
      iframeDoc.body?.focus();
      canvas?.focus();
    } catch (error) {
      console.error('Could not focus Unity game:', error);
    }
  }, []);

  const triggerUnityFullscreen = useCallback(() => {
    try {
      const iframe = iframeRef.current;
      if (!iframe) return;

      const iframeDoc =
        iframe.contentDocument || iframe.contentWindow?.document;
      if (!iframeDoc) return;

      const unityFullscreenButton = iframeDoc.querySelector('#unity-fullscreen-button');
      if (unityFullscreenButton) {
        unityFullscreenButton.click();
        setShowHint(false);

        requestAnimationFrame(() => {
          focusUnityGame();
        });

        setTimeout(() => {
          focusUnityGame();
        }, 100);

        setTimeout(() => {
          focusUnityGame();
        }, 300);
      }
    } catch (error) {
      console.error('Could not trigger Unity fullscreen:', error);
    }
  }, [focusUnityGame]);

  useEffect(() => {
    const handleParentKeyDown = (event) => {
      const activeTag = document.activeElement?.tagName;
      const isTyping =
        activeTag === 'INPUT' ||
        activeTag === 'TEXTAREA' ||
        document.activeElement?.isContentEditable;

      if (isTyping) return;

      if (event.key === 'f' || event.key === 'F') {
        event.preventDefault();
        triggerUnityFullscreen();
      }
    };

    window.addEventListener('keydown', handleParentKeyDown);
    return () => {
      window.removeEventListener('keydown', handleParentKeyDown);
    };
  }, [triggerUnityFullscreen]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    let iframeDoc = null;
    let iframeWindow = null;

    const handleIframeKeyDown = (event) => {
      if (event.key === 'f' || event.key === 'F') {
        event.preventDefault();
        event.stopPropagation();
        triggerUnityFullscreen();
      }
    };

    const attachIframeListeners = () => {
      try {
        iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        iframeWindow = iframe.contentWindow;

        if (iframeDoc) {
          iframeDoc.addEventListener('keydown', handleIframeKeyDown, true);
        }

        if (iframeWindow) {
          iframeWindow.addEventListener('keydown', handleIframeKeyDown, true);
        }
      } catch (error) {
        console.error('Could not attach iframe key listeners:', error);
      }
    };

    iframe.addEventListener('load', attachIframeListeners);

    if (
      iframe.contentDocument?.readyState === 'complete' ||
      iframe.contentDocument?.readyState === 'interactive'
    ) {
      attachIframeListeners();
    }

    return () => {
      iframe.removeEventListener('load', attachIframeListeners);

      if (iframeDoc) {
        iframeDoc.removeEventListener('keydown', handleIframeKeyDown, true);
      }

      if (iframeWindow) {
        iframeWindow.removeEventListener('keydown', handleIframeKeyDown, true);
      }
    };
  }, [triggerUnityFullscreen]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHint(false);
    }, 25000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => {
      if (document.fullscreenElement) {
        setTimeout(() => {
          focusUnityGame();
        }, 100);
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, [focusUnityGame]);

  return (
    <div className="game-window-container">
      <div className="game-window">
        {showHint && (
          <div className="fullscreen-hint-overlay">
            Press <strong>F</strong> for fullscreen
          </div>
        )}

        <iframe
          ref={iframeRef}
          src="/gameindex.html"
          title="Unity Game"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          tabIndex="0"
        ></iframe>
      </div>
    </div>
  );
};

export default GameWindow;

// import React from 'react';
// import './GameWindow.css'; // Add a separate CSS file for styling

// const GameWindow = () => {
//   return (
//     <div className="game-window-container">
//       <div className="game-window">
//         <iframe
//           src="/gameindex.html"  
//           title="Unity Game"
//           width="100%"
//           height="100%"
//           frameBorder="0"
//           allowFullScreen
//         ></iframe>
//       </div>
//     </div>
//   );
// };

// export default GameWindow;
